import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202509: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202509",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-09-01",
  endDate: "2025-09-30",
  impressions: 79695,
  clicks: 1818,
  adsSpendDollars: 4230,
  budgetDollars: 4300,
  salesDollars: 9643,
  bestEstimateRoas: 2.28,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.98,
  newCustomersAcquired: 30,
  dataAvailableAtDate: "2025-10-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
